"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryHealthFactorResponse = exports.QueryHealthFactorRequest = exports.QueryEModeResponse = exports.QueryEModeRequest = exports.QueryStablecoinInterestResponse = exports.QueryStablecoinInterestRequest = exports.QueryEModeAllResponse = exports.QueryEModeAllRequest = exports.QueryRewardDebtsAllRequest = exports.QueryRewardDebtsResponse = exports.QueryRewardDebtsRequest = exports.QueryRewardSchemesAllResponse = exports.QueryRewardSchemesAllRequest = exports.QueryCdpPositionsResponse = exports.QueryCdpPositionsRequest = exports.QueryCdpPositionResponse = exports.QueryCdpPositionRequest = exports.CdpPosition = exports.CdpPositionItem = exports.QueryStablecoinDebtResponse = exports.QueryStablecoinDebtRequest = exports.QueryTokenDebtAllResponse = exports.QueryTokenDebtAllRequest = exports.QueryTokenDebtResponse = exports.QueryTokenDebtRequest = exports.QueryAssetAllResponse = exports.QueryAssetAllRequest = exports.QueryAssetResponse = exports.QueryAssetRequest = exports.QueryAccountStablecoinResponse = exports.QueryAccountStablecoinRequest = exports.Debt = exports.QueryAccountDebtAllResponse = exports.QueryAccountDebtAllRequest = exports.QueryAccountDebtResponse = exports.QueryAccountDebtRequest = exports.Collateral = exports.QueryAccountCollateralAllResponse = exports.QueryAccountCollateralAllRequest = exports.QueryAccountCollateralResponse = exports.QueryAccountCollateralRequest = exports.QueryAccountDataResponse = exports.QueryAccountDataRequest = exports.QueryRateStrategyAllResponse = exports.QueryRateStrategyAllRequest = exports.QueryRateStrategyResponse = exports.QueryRateStrategyRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
exports.QueryClientImpl = exports.QueryCDPLiquidationsAllResponse = exports.QueryCDPLiquidationsAllRequest = exports.QueryAccountEModeResponse = exports.QueryAccountEModeRequest = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const params_1 = require("./params");
const rate_strategy_params_1 = require("./rate_strategy_params");
const pagination_1 = require("../../../cosmos/base/query/v1beta1/pagination");
const asset_params_1 = require("./asset_params");
const debt_info_1 = require("./debt_info");
const stablecoin_debt_info_1 = require("./stablecoin_debt_info");
const stablecoin_interest_info_1 = require("./stablecoin_interest_info");
const e_mode_category_1 = require("./e_mode_category");
const coin_1 = require("../../../cosmos/base/v1beta1/coin");
const reward_scheme_1 = require("./reward_scheme");
const cdp_liquidations_1 = require("./cdp_liquidations");
exports.protobufPackage = "Switcheo.carbon.cdp";
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromPartial(object.params)
                : undefined;
        return message;
    },
};
const baseQueryRateStrategyRequest = { name: "" };
exports.QueryRateStrategyRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRateStrategyRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRateStrategyRequest);
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryRateStrategyRequest);
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryRateStrategyResponse = {};
exports.QueryRateStrategyResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rateStrategyParams !== undefined) {
            rate_strategy_params_1.RateStrategyParams.encode(message.rateStrategyParams, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRateStrategyResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rateStrategyParams = rate_strategy_params_1.RateStrategyParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRateStrategyResponse);
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromJSON(object.rateStrategyParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.rateStrategyParams !== undefined &&
            (obj.rateStrategyParams = message.rateStrategyParams
                ? rate_strategy_params_1.RateStrategyParams.toJSON(message.rateStrategyParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryRateStrategyResponse);
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromPartial(object.rateStrategyParams)
                : undefined;
        return message;
    },
};
const baseQueryRateStrategyAllRequest = {};
exports.QueryRateStrategyAllRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRateStrategyAllRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRateStrategyAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryRateStrategyAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryRateStrategyAllResponse = {};
exports.QueryRateStrategyAllResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.rateStrategyParamsAll) {
            rate_strategy_params_1.RateStrategyParams.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRateStrategyAllResponse);
        message.rateStrategyParamsAll = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rateStrategyParamsAll.push(rate_strategy_params_1.RateStrategyParams.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryRateStrategyAllResponse);
        message.rateStrategyParamsAll = ((_a = object.rateStrategyParamsAll) !== null && _a !== void 0 ? _a : []).map((e) => rate_strategy_params_1.RateStrategyParams.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rateStrategyParamsAll) {
            obj.rateStrategyParamsAll = message.rateStrategyParamsAll.map((e) => e ? rate_strategy_params_1.RateStrategyParams.toJSON(e) : undefined);
        }
        else {
            obj.rateStrategyParamsAll = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryRateStrategyAllResponse);
        message.rateStrategyParamsAll = ((_a = object.rateStrategyParamsAll) !== null && _a !== void 0 ? _a : []).map((e) => rate_strategy_params_1.RateStrategyParams.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAccountDataRequest = { address: "" };
exports.QueryAccountDataRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountDataRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAccountDataRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAccountDataRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryAccountDataResponse = {
    totalCollateralsUsd: "",
    totalDebtsUsd: "",
    availableBorrowsUsd: "",
    currLiquidationThreshold: "",
};
exports.QueryAccountDataResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.totalCollateralsUsd !== "") {
            writer.uint32(10).string(message.totalCollateralsUsd);
        }
        if (message.totalDebtsUsd !== "") {
            writer.uint32(18).string(message.totalDebtsUsd);
        }
        if (message.availableBorrowsUsd !== "") {
            writer.uint32(26).string(message.availableBorrowsUsd);
        }
        if (message.currLiquidationThreshold !== "") {
            writer.uint32(34).string(message.currLiquidationThreshold);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountDataResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.totalCollateralsUsd = reader.string();
                    break;
                case 2:
                    message.totalDebtsUsd = reader.string();
                    break;
                case 3:
                    message.availableBorrowsUsd = reader.string();
                    break;
                case 4:
                    message.currLiquidationThreshold = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAccountDataResponse);
        message.totalCollateralsUsd =
            object.totalCollateralsUsd !== undefined &&
                object.totalCollateralsUsd !== null
                ? String(object.totalCollateralsUsd)
                : "";
        message.totalDebtsUsd =
            object.totalDebtsUsd !== undefined && object.totalDebtsUsd !== null
                ? String(object.totalDebtsUsd)
                : "";
        message.availableBorrowsUsd =
            object.availableBorrowsUsd !== undefined &&
                object.availableBorrowsUsd !== null
                ? String(object.availableBorrowsUsd)
                : "";
        message.currLiquidationThreshold =
            object.currLiquidationThreshold !== undefined &&
                object.currLiquidationThreshold !== null
                ? String(object.currLiquidationThreshold)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.totalCollateralsUsd !== undefined &&
            (obj.totalCollateralsUsd = message.totalCollateralsUsd);
        message.totalDebtsUsd !== undefined &&
            (obj.totalDebtsUsd = message.totalDebtsUsd);
        message.availableBorrowsUsd !== undefined &&
            (obj.availableBorrowsUsd = message.availableBorrowsUsd);
        message.currLiquidationThreshold !== undefined &&
            (obj.currLiquidationThreshold = message.currLiquidationThreshold);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseQueryAccountDataResponse);
        message.totalCollateralsUsd = (_a = object.totalCollateralsUsd) !== null && _a !== void 0 ? _a : "";
        message.totalDebtsUsd = (_b = object.totalDebtsUsd) !== null && _b !== void 0 ? _b : "";
        message.availableBorrowsUsd = (_c = object.availableBorrowsUsd) !== null && _c !== void 0 ? _c : "";
        message.currLiquidationThreshold = (_d = object.currLiquidationThreshold) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
const baseQueryAccountCollateralRequest = {
    address: "",
    cibtDenom: "",
};
exports.QueryAccountCollateralRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.cibtDenom !== "") {
            writer.uint32(18).string(message.cibtDenom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountCollateralRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.cibtDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAccountCollateralRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.cibtDenom =
            object.cibtDenom !== undefined && object.cibtDenom !== null
                ? String(object.cibtDenom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.cibtDenom !== undefined && (obj.cibtDenom = message.cibtDenom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryAccountCollateralRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.cibtDenom = (_b = object.cibtDenom) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseQueryAccountCollateralResponse = {};
exports.QueryAccountCollateralResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.collateral !== undefined) {
            exports.Collateral.encode(message.collateral, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountCollateralResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.collateral = exports.Collateral.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAccountCollateralResponse);
        message.collateral =
            object.collateral !== undefined && object.collateral !== null
                ? exports.Collateral.fromJSON(object.collateral)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.collateral !== undefined &&
            (obj.collateral = message.collateral
                ? exports.Collateral.toJSON(message.collateral)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAccountCollateralResponse);
        message.collateral =
            object.collateral !== undefined && object.collateral !== null
                ? exports.Collateral.fromPartial(object.collateral)
                : undefined;
        return message;
    },
};
const baseQueryAccountCollateralAllRequest = { address: "" };
exports.QueryAccountCollateralAllRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountCollateralAllRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAccountCollateralAllRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAccountCollateralAllRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAccountCollateralAllResponse = {};
exports.QueryAccountCollateralAllResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.collaterals) {
            exports.Collateral.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountCollateralAllResponse);
        message.collaterals = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.collaterals.push(exports.Collateral.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAccountCollateralAllResponse);
        message.collaterals = ((_a = object.collaterals) !== null && _a !== void 0 ? _a : []).map((e) => exports.Collateral.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.collaterals) {
            obj.collaterals = message.collaterals.map((e) => e ? exports.Collateral.toJSON(e) : undefined);
        }
        else {
            obj.collaterals = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAccountCollateralAllResponse);
        message.collaterals = ((_a = object.collaterals) !== null && _a !== void 0 ? _a : []).map((e) => exports.Collateral.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseCollateral = {
    denom: "",
    cibtDenom: "",
    collateralAmount: "",
};
exports.Collateral = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.cibtDenom !== "") {
            writer.uint32(18).string(message.cibtDenom);
        }
        if (message.collateralAmount !== "") {
            writer.uint32(26).string(message.collateralAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCollateral);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.cibtDenom = reader.string();
                    break;
                case 3:
                    message.collateralAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseCollateral);
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.cibtDenom =
            object.cibtDenom !== undefined && object.cibtDenom !== null
                ? String(object.cibtDenom)
                : "";
        message.collateralAmount =
            object.collateralAmount !== undefined && object.collateralAmount !== null
                ? String(object.collateralAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.cibtDenom !== undefined && (obj.cibtDenom = message.cibtDenom);
        message.collateralAmount !== undefined &&
            (obj.collateralAmount = message.collateralAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseCollateral);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.cibtDenom = (_b = object.cibtDenom) !== null && _b !== void 0 ? _b : "";
        message.collateralAmount = (_c = object.collateralAmount) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseQueryAccountDebtRequest = { address: "", denom: "" };
exports.QueryAccountDebtRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountDebtRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAccountDebtRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryAccountDebtRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseQueryAccountDebtResponse = {};
exports.QueryAccountDebtResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.debt !== undefined) {
            exports.Debt.encode(message.debt, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountDebtResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.debt = exports.Debt.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAccountDebtResponse);
        message.debt =
            object.debt !== undefined && object.debt !== null
                ? exports.Debt.fromJSON(object.debt)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.debt !== undefined &&
            (obj.debt = message.debt ? exports.Debt.toJSON(message.debt) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAccountDebtResponse);
        message.debt =
            object.debt !== undefined && object.debt !== null
                ? exports.Debt.fromPartial(object.debt)
                : undefined;
        return message;
    },
};
const baseQueryAccountDebtAllRequest = { address: "" };
exports.QueryAccountDebtAllRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountDebtAllRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAccountDebtAllRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAccountDebtAllRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAccountDebtAllResponse = {};
exports.QueryAccountDebtAllResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.debts) {
            exports.Debt.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountDebtAllResponse);
        message.debts = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.debts.push(exports.Debt.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAccountDebtAllResponse);
        message.debts = ((_a = object.debts) !== null && _a !== void 0 ? _a : []).map((e) => exports.Debt.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.debts) {
            obj.debts = message.debts.map((e) => (e ? exports.Debt.toJSON(e) : undefined));
        }
        else {
            obj.debts = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAccountDebtAllResponse);
        message.debts = ((_a = object.debts) !== null && _a !== void 0 ? _a : []).map((e) => exports.Debt.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseDebt = {
    denom: "",
    principal: "",
    initialCumulativeInterestMultiplier: "",
};
exports.Debt = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.principal !== "") {
            writer.uint32(18).string(message.principal);
        }
        if (message.initialCumulativeInterestMultiplier !== "") {
            writer.uint32(26).string(message.initialCumulativeInterestMultiplier);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDebt);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.principal = reader.string();
                    break;
                case 3:
                    message.initialCumulativeInterestMultiplier = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDebt);
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.principal =
            object.principal !== undefined && object.principal !== null
                ? String(object.principal)
                : "";
        message.initialCumulativeInterestMultiplier =
            object.initialCumulativeInterestMultiplier !== undefined &&
                object.initialCumulativeInterestMultiplier !== null
                ? String(object.initialCumulativeInterestMultiplier)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.principal !== undefined && (obj.principal = message.principal);
        message.initialCumulativeInterestMultiplier !== undefined &&
            (obj.initialCumulativeInterestMultiplier =
                message.initialCumulativeInterestMultiplier);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseDebt);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.principal = (_b = object.principal) !== null && _b !== void 0 ? _b : "";
        message.initialCumulativeInterestMultiplier =
            (_c = object.initialCumulativeInterestMultiplier) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseQueryAccountStablecoinRequest = { address: "" };
exports.QueryAccountStablecoinRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountStablecoinRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAccountStablecoinRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAccountStablecoinRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryAccountStablecoinResponse = {
    principal: "",
    interest: "",
    initialCumulativeInterestMultiplier: "",
};
exports.QueryAccountStablecoinResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.principal !== "") {
            writer.uint32(10).string(message.principal);
        }
        if (message.interest !== "") {
            writer.uint32(18).string(message.interest);
        }
        if (message.initialCumulativeInterestMultiplier !== "") {
            writer.uint32(26).string(message.initialCumulativeInterestMultiplier);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountStablecoinResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.principal = reader.string();
                    break;
                case 2:
                    message.interest = reader.string();
                    break;
                case 3:
                    message.initialCumulativeInterestMultiplier = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAccountStablecoinResponse);
        message.principal =
            object.principal !== undefined && object.principal !== null
                ? String(object.principal)
                : "";
        message.interest =
            object.interest !== undefined && object.interest !== null
                ? String(object.interest)
                : "";
        message.initialCumulativeInterestMultiplier =
            object.initialCumulativeInterestMultiplier !== undefined &&
                object.initialCumulativeInterestMultiplier !== null
                ? String(object.initialCumulativeInterestMultiplier)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.principal !== undefined && (obj.principal = message.principal);
        message.interest !== undefined && (obj.interest = message.interest);
        message.initialCumulativeInterestMultiplier !== undefined &&
            (obj.initialCumulativeInterestMultiplier =
                message.initialCumulativeInterestMultiplier);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseQueryAccountStablecoinResponse);
        message.principal = (_a = object.principal) !== null && _a !== void 0 ? _a : "";
        message.interest = (_b = object.interest) !== null && _b !== void 0 ? _b : "";
        message.initialCumulativeInterestMultiplier =
            (_c = object.initialCumulativeInterestMultiplier) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseQueryAssetRequest = { denom: "" };
exports.QueryAssetRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAssetRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAssetRequest);
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAssetRequest);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryAssetResponse = {};
exports.QueryAssetResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.assetParams !== undefined) {
            asset_params_1.AssetParamsAPI.encode(message.assetParams, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAssetResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.assetParams = asset_params_1.AssetParamsAPI.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAssetResponse);
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.AssetParamsAPI.fromJSON(object.assetParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.assetParams !== undefined &&
            (obj.assetParams = message.assetParams
                ? asset_params_1.AssetParamsAPI.toJSON(message.assetParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAssetResponse);
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.AssetParamsAPI.fromPartial(object.assetParams)
                : undefined;
        return message;
    },
};
const baseQueryAssetAllRequest = {};
exports.QueryAssetAllRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAssetAllRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAssetAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAssetAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAssetAllResponse = {};
exports.QueryAssetAllResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.assetParamsAll) {
            asset_params_1.AssetParamsAPI.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAssetAllResponse);
        message.assetParamsAll = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.assetParamsAll.push(asset_params_1.AssetParamsAPI.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAssetAllResponse);
        message.assetParamsAll = ((_a = object.assetParamsAll) !== null && _a !== void 0 ? _a : []).map((e) => asset_params_1.AssetParamsAPI.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.assetParamsAll) {
            obj.assetParamsAll = message.assetParamsAll.map((e) => e ? asset_params_1.AssetParamsAPI.toJSON(e) : undefined);
        }
        else {
            obj.assetParamsAll = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAssetAllResponse);
        message.assetParamsAll = ((_a = object.assetParamsAll) !== null && _a !== void 0 ? _a : []).map((e) => asset_params_1.AssetParamsAPI.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryTokenDebtRequest = { denom: "" };
exports.QueryTokenDebtRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryTokenDebtRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryTokenDebtRequest);
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryTokenDebtRequest);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryTokenDebtResponse = {};
exports.QueryTokenDebtResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.debtInfo !== undefined) {
            debt_info_1.DebtInfo.encode(message.debtInfo, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryTokenDebtResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.debtInfo = debt_info_1.DebtInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryTokenDebtResponse);
        message.debtInfo =
            object.debtInfo !== undefined && object.debtInfo !== null
                ? debt_info_1.DebtInfo.fromJSON(object.debtInfo)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.debtInfo !== undefined &&
            (obj.debtInfo = message.debtInfo
                ? debt_info_1.DebtInfo.toJSON(message.debtInfo)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryTokenDebtResponse);
        message.debtInfo =
            object.debtInfo !== undefined && object.debtInfo !== null
                ? debt_info_1.DebtInfo.fromPartial(object.debtInfo)
                : undefined;
        return message;
    },
};
const baseQueryTokenDebtAllRequest = {};
exports.QueryTokenDebtAllRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryTokenDebtAllRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryTokenDebtAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryTokenDebtAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryTokenDebtAllResponse = {};
exports.QueryTokenDebtAllResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.debtInfosAll) {
            debt_info_1.DebtInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryTokenDebtAllResponse);
        message.debtInfosAll = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.debtInfosAll.push(debt_info_1.DebtInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryTokenDebtAllResponse);
        message.debtInfosAll = ((_a = object.debtInfosAll) !== null && _a !== void 0 ? _a : []).map((e) => debt_info_1.DebtInfo.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.debtInfosAll) {
            obj.debtInfosAll = message.debtInfosAll.map((e) => e ? debt_info_1.DebtInfo.toJSON(e) : undefined);
        }
        else {
            obj.debtInfosAll = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryTokenDebtAllResponse);
        message.debtInfosAll = ((_a = object.debtInfosAll) !== null && _a !== void 0 ? _a : []).map((e) => debt_info_1.DebtInfo.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryStablecoinDebtRequest = {};
exports.QueryStablecoinDebtRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryStablecoinDebtRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryStablecoinDebtRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryStablecoinDebtRequest);
        return message;
    },
};
const baseQueryStablecoinDebtResponse = {};
exports.QueryStablecoinDebtResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.stablecoinDebtInfo !== undefined) {
            stablecoin_debt_info_1.StablecoinDebtInfo.encode(message.stablecoinDebtInfo, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryStablecoinDebtResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.stablecoinDebtInfo = stablecoin_debt_info_1.StablecoinDebtInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryStablecoinDebtResponse);
        message.stablecoinDebtInfo =
            object.stablecoinDebtInfo !== undefined &&
                object.stablecoinDebtInfo !== null
                ? stablecoin_debt_info_1.StablecoinDebtInfo.fromJSON(object.stablecoinDebtInfo)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.stablecoinDebtInfo !== undefined &&
            (obj.stablecoinDebtInfo = message.stablecoinDebtInfo
                ? stablecoin_debt_info_1.StablecoinDebtInfo.toJSON(message.stablecoinDebtInfo)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryStablecoinDebtResponse);
        message.stablecoinDebtInfo =
            object.stablecoinDebtInfo !== undefined &&
                object.stablecoinDebtInfo !== null
                ? stablecoin_debt_info_1.StablecoinDebtInfo.fromPartial(object.stablecoinDebtInfo)
                : undefined;
        return message;
    },
};
const baseCdpPositionItem = {
    address: "",
    denom: "",
    cibtDenom: "",
    healthFactor: "",
    collateralAmount: "",
    borrowAmount: "",
    mintDenom: "",
    mintAmount: "",
};
exports.CdpPositionItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.cibtDenom !== "") {
            writer.uint32(26).string(message.cibtDenom);
        }
        if (message.healthFactor !== "") {
            writer.uint32(34).string(message.healthFactor);
        }
        if (message.collateralAmount !== "") {
            writer.uint32(42).string(message.collateralAmount);
        }
        if (message.borrowAmount !== "") {
            writer.uint32(50).string(message.borrowAmount);
        }
        if (message.mintDenom !== "") {
            writer.uint32(58).string(message.mintDenom);
        }
        if (message.mintAmount !== "") {
            writer.uint32(66).string(message.mintAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCdpPositionItem);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.cibtDenom = reader.string();
                    break;
                case 4:
                    message.healthFactor = reader.string();
                    break;
                case 5:
                    message.collateralAmount = reader.string();
                    break;
                case 6:
                    message.borrowAmount = reader.string();
                    break;
                case 7:
                    message.mintDenom = reader.string();
                    break;
                case 8:
                    message.mintAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseCdpPositionItem);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.cibtDenom =
            object.cibtDenom !== undefined && object.cibtDenom !== null
                ? String(object.cibtDenom)
                : "";
        message.healthFactor =
            object.healthFactor !== undefined && object.healthFactor !== null
                ? String(object.healthFactor)
                : "";
        message.collateralAmount =
            object.collateralAmount !== undefined && object.collateralAmount !== null
                ? String(object.collateralAmount)
                : "";
        message.borrowAmount =
            object.borrowAmount !== undefined && object.borrowAmount !== null
                ? String(object.borrowAmount)
                : "";
        message.mintDenom =
            object.mintDenom !== undefined && object.mintDenom !== null
                ? String(object.mintDenom)
                : "";
        message.mintAmount =
            object.mintAmount !== undefined && object.mintAmount !== null
                ? String(object.mintAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        message.cibtDenom !== undefined && (obj.cibtDenom = message.cibtDenom);
        message.healthFactor !== undefined &&
            (obj.healthFactor = message.healthFactor);
        message.collateralAmount !== undefined &&
            (obj.collateralAmount = message.collateralAmount);
        message.borrowAmount !== undefined &&
            (obj.borrowAmount = message.borrowAmount);
        message.mintDenom !== undefined && (obj.mintDenom = message.mintDenom);
        message.mintAmount !== undefined && (obj.mintAmount = message.mintAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = Object.assign({}, baseCdpPositionItem);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.cibtDenom = (_c = object.cibtDenom) !== null && _c !== void 0 ? _c : "";
        message.healthFactor = (_d = object.healthFactor) !== null && _d !== void 0 ? _d : "";
        message.collateralAmount = (_e = object.collateralAmount) !== null && _e !== void 0 ? _e : "";
        message.borrowAmount = (_f = object.borrowAmount) !== null && _f !== void 0 ? _f : "";
        message.mintDenom = (_g = object.mintDenom) !== null && _g !== void 0 ? _g : "";
        message.mintAmount = (_h = object.mintAmount) !== null && _h !== void 0 ? _h : "";
        return message;
    },
};
const baseCdpPosition = { address: "", healthFactor: "" };
exports.CdpPosition = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.healthFactor !== "") {
            writer.uint32(18).string(message.healthFactor);
        }
        for (const v of message.collateral) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.borrow) {
            coin_1.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.mint) {
            coin_1.Coin.encode(v, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCdpPosition);
        message.collateral = [];
        message.borrow = [];
        message.mint = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.healthFactor = reader.string();
                    break;
                case 3:
                    message.collateral.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.borrow.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.mint.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseCdpPosition);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.healthFactor =
            object.healthFactor !== undefined && object.healthFactor !== null
                ? String(object.healthFactor)
                : "";
        message.collateral = ((_a = object.collateral) !== null && _a !== void 0 ? _a : []).map((e) => coin_1.Coin.fromJSON(e));
        message.borrow = ((_b = object.borrow) !== null && _b !== void 0 ? _b : []).map((e) => coin_1.Coin.fromJSON(e));
        message.mint = ((_c = object.mint) !== null && _c !== void 0 ? _c : []).map((e) => coin_1.Coin.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.healthFactor !== undefined &&
            (obj.healthFactor = message.healthFactor);
        if (message.collateral) {
            obj.collateral = message.collateral.map((e) => e ? coin_1.Coin.toJSON(e) : undefined);
        }
        else {
            obj.collateral = [];
        }
        if (message.borrow) {
            obj.borrow = message.borrow.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.borrow = [];
        }
        if (message.mint) {
            obj.mint = message.mint.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.mint = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseCdpPosition);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.healthFactor = (_b = object.healthFactor) !== null && _b !== void 0 ? _b : "";
        message.collateral = ((_c = object.collateral) !== null && _c !== void 0 ? _c : []).map((e) => coin_1.Coin.fromPartial(e));
        message.borrow = ((_d = object.borrow) !== null && _d !== void 0 ? _d : []).map((e) => coin_1.Coin.fromPartial(e));
        message.mint = ((_e = object.mint) !== null && _e !== void 0 ? _e : []).map((e) => coin_1.Coin.fromPartial(e));
        return message;
    },
};
const baseQueryCdpPositionRequest = { address: "" };
exports.QueryCdpPositionRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCdpPositionRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryCdpPositionRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryCdpPositionRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryCdpPositionResponse = {};
exports.QueryCdpPositionResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.position !== undefined) {
            exports.CdpPosition.encode(message.position, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCdpPositionResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.position = exports.CdpPosition.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryCdpPositionResponse);
        message.position =
            object.position !== undefined && object.position !== null
                ? exports.CdpPosition.fromJSON(object.position)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.position !== undefined &&
            (obj.position = message.position
                ? exports.CdpPosition.toJSON(message.position)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryCdpPositionResponse);
        message.position =
            object.position !== undefined && object.position !== null
                ? exports.CdpPosition.fromPartial(object.position)
                : undefined;
        return message;
    },
};
const baseQueryCdpPositionsRequest = {
    maxHealthFactor: "",
    minHealthFactor: "",
};
exports.QueryCdpPositionsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        if (message.maxHealthFactor !== "") {
            writer.uint32(18).string(message.maxHealthFactor);
        }
        if (message.minHealthFactor !== "") {
            writer.uint32(26).string(message.minHealthFactor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCdpPositionsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.maxHealthFactor = reader.string();
                    break;
                case 3:
                    message.minHealthFactor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryCdpPositionsRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        message.maxHealthFactor =
            object.maxHealthFactor !== undefined && object.maxHealthFactor !== null
                ? String(object.maxHealthFactor)
                : "";
        message.minHealthFactor =
            object.minHealthFactor !== undefined && object.minHealthFactor !== null
                ? String(object.minHealthFactor)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        message.maxHealthFactor !== undefined &&
            (obj.maxHealthFactor = message.maxHealthFactor);
        message.minHealthFactor !== undefined &&
            (obj.minHealthFactor = message.minHealthFactor);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryCdpPositionsRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        message.maxHealthFactor = (_a = object.maxHealthFactor) !== null && _a !== void 0 ? _a : "";
        message.minHealthFactor = (_b = object.minHealthFactor) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseQueryCdpPositionsResponse = {};
exports.QueryCdpPositionsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.positions) {
            exports.CdpPosition.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCdpPositionsResponse);
        message.positions = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.positions.push(exports.CdpPosition.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryCdpPositionsResponse);
        message.positions = ((_a = object.positions) !== null && _a !== void 0 ? _a : []).map((e) => exports.CdpPosition.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.positions) {
            obj.positions = message.positions.map((e) => e ? exports.CdpPosition.toJSON(e) : undefined);
        }
        else {
            obj.positions = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryCdpPositionsResponse);
        message.positions = ((_a = object.positions) !== null && _a !== void 0 ? _a : []).map((e) => exports.CdpPosition.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryRewardSchemesAllRequest = {};
exports.QueryRewardSchemesAllRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRewardSchemesAllRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRewardSchemesAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryRewardSchemesAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryRewardSchemesAllResponse = {};
exports.QueryRewardSchemesAllResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.rewardSchemes) {
            reward_scheme_1.RewardScheme.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRewardSchemesAllResponse);
        message.rewardSchemes = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewardSchemes.push(reward_scheme_1.RewardScheme.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryRewardSchemesAllResponse);
        message.rewardSchemes = ((_a = object.rewardSchemes) !== null && _a !== void 0 ? _a : []).map((e) => reward_scheme_1.RewardScheme.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rewardSchemes) {
            obj.rewardSchemes = message.rewardSchemes.map((e) => e ? reward_scheme_1.RewardScheme.toJSON(e) : undefined);
        }
        else {
            obj.rewardSchemes = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryRewardSchemesAllResponse);
        message.rewardSchemes = ((_a = object.rewardSchemes) !== null && _a !== void 0 ? _a : []).map((e) => reward_scheme_1.RewardScheme.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryRewardDebtsRequest = { address: "" };
exports.QueryRewardDebtsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRewardDebtsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRewardDebtsRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryRewardDebtsRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryRewardDebtsResponse = {};
exports.QueryRewardDebtsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.rewardDebts) {
            reward_scheme_1.RewardDebt.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRewardDebtsResponse);
        message.rewardDebts = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewardDebts.push(reward_scheme_1.RewardDebt.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryRewardDebtsResponse);
        message.rewardDebts = ((_a = object.rewardDebts) !== null && _a !== void 0 ? _a : []).map((e) => reward_scheme_1.RewardDebt.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rewardDebts) {
            obj.rewardDebts = message.rewardDebts.map((e) => e ? reward_scheme_1.RewardDebt.toJSON(e) : undefined);
        }
        else {
            obj.rewardDebts = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryRewardDebtsResponse);
        message.rewardDebts = ((_a = object.rewardDebts) !== null && _a !== void 0 ? _a : []).map((e) => reward_scheme_1.RewardDebt.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryRewardDebtsAllRequest = {};
exports.QueryRewardDebtsAllRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRewardDebtsAllRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRewardDebtsAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryRewardDebtsAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryEModeAllRequest = {};
exports.QueryEModeAllRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryEModeAllRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryEModeAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryEModeAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryEModeAllResponse = {};
exports.QueryEModeAllResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.eModeCategories) {
            e_mode_category_1.EModeCategory.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryEModeAllResponse);
        message.eModeCategories = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.eModeCategories.push(e_mode_category_1.EModeCategory.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryEModeAllResponse);
        message.eModeCategories = ((_a = object.eModeCategories) !== null && _a !== void 0 ? _a : []).map((e) => e_mode_category_1.EModeCategory.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.eModeCategories) {
            obj.eModeCategories = message.eModeCategories.map((e) => e ? e_mode_category_1.EModeCategory.toJSON(e) : undefined);
        }
        else {
            obj.eModeCategories = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryEModeAllResponse);
        message.eModeCategories = ((_a = object.eModeCategories) !== null && _a !== void 0 ? _a : []).map((e) => e_mode_category_1.EModeCategory.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryStablecoinInterestRequest = {};
exports.QueryStablecoinInterestRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryStablecoinInterestRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryStablecoinInterestRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryStablecoinInterestRequest);
        return message;
    },
};
const baseQueryStablecoinInterestResponse = {};
exports.QueryStablecoinInterestResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.stablecoinInterestInfo !== undefined) {
            stablecoin_interest_info_1.StablecoinInterestInfo.encode(message.stablecoinInterestInfo, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryStablecoinInterestResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.stablecoinInterestInfo = stablecoin_interest_info_1.StablecoinInterestInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryStablecoinInterestResponse);
        message.stablecoinInterestInfo =
            object.stablecoinInterestInfo !== undefined &&
                object.stablecoinInterestInfo !== null
                ? stablecoin_interest_info_1.StablecoinInterestInfo.fromJSON(object.stablecoinInterestInfo)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.stablecoinInterestInfo !== undefined &&
            (obj.stablecoinInterestInfo = message.stablecoinInterestInfo
                ? stablecoin_interest_info_1.StablecoinInterestInfo.toJSON(message.stablecoinInterestInfo)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryStablecoinInterestResponse);
        message.stablecoinInterestInfo =
            object.stablecoinInterestInfo !== undefined &&
                object.stablecoinInterestInfo !== null
                ? stablecoin_interest_info_1.StablecoinInterestInfo.fromPartial(object.stablecoinInterestInfo)
                : undefined;
        return message;
    },
};
const baseQueryEModeRequest = { name: "" };
exports.QueryEModeRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryEModeRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryEModeRequest);
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryEModeRequest);
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryEModeResponse = {};
exports.QueryEModeResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.eModeCategory !== undefined) {
            e_mode_category_1.EModeCategory.encode(message.eModeCategory, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryEModeResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.eModeCategory = e_mode_category_1.EModeCategory.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryEModeResponse);
        message.eModeCategory =
            object.eModeCategory !== undefined && object.eModeCategory !== null
                ? e_mode_category_1.EModeCategory.fromJSON(object.eModeCategory)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.eModeCategory !== undefined &&
            (obj.eModeCategory = message.eModeCategory
                ? e_mode_category_1.EModeCategory.toJSON(message.eModeCategory)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryEModeResponse);
        message.eModeCategory =
            object.eModeCategory !== undefined && object.eModeCategory !== null
                ? e_mode_category_1.EModeCategory.fromPartial(object.eModeCategory)
                : undefined;
        return message;
    },
};
const baseQueryHealthFactorRequest = { address: "" };
exports.QueryHealthFactorRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryHealthFactorRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryHealthFactorRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryHealthFactorRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryHealthFactorResponse = { healthFactor: "" };
exports.QueryHealthFactorResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.healthFactor !== "") {
            writer.uint32(10).string(message.healthFactor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryHealthFactorResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.healthFactor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryHealthFactorResponse);
        message.healthFactor =
            object.healthFactor !== undefined && object.healthFactor !== null
                ? String(object.healthFactor)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.healthFactor !== undefined &&
            (obj.healthFactor = message.healthFactor);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryHealthFactorResponse);
        message.healthFactor = (_a = object.healthFactor) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryAccountEModeRequest = { address: "" };
exports.QueryAccountEModeRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountEModeRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAccountEModeRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAccountEModeRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryAccountEModeResponse = { eModeCategoryName: "" };
exports.QueryAccountEModeResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.eModeCategoryName !== "") {
            writer.uint32(10).string(message.eModeCategoryName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAccountEModeResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.eModeCategoryName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAccountEModeResponse);
        message.eModeCategoryName =
            object.eModeCategoryName !== undefined &&
                object.eModeCategoryName !== null
                ? String(object.eModeCategoryName)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.eModeCategoryName !== undefined &&
            (obj.eModeCategoryName = message.eModeCategoryName);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAccountEModeResponse);
        message.eModeCategoryName = (_a = object.eModeCategoryName) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryCDPLiquidationsAllRequest = {};
exports.QueryCDPLiquidationsAllRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCDPLiquidationsAllRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryCDPLiquidationsAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryCDPLiquidationsAllRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryCDPLiquidationsAllResponse = {};
exports.QueryCDPLiquidationsAllResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.cdpLiquidationsAll) {
            cdp_liquidations_1.CDPLiquidations.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCDPLiquidationsAllResponse);
        message.cdpLiquidationsAll = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cdpLiquidationsAll.push(cdp_liquidations_1.CDPLiquidations.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryCDPLiquidationsAllResponse);
        message.cdpLiquidationsAll = ((_a = object.cdpLiquidationsAll) !== null && _a !== void 0 ? _a : []).map((e) => cdp_liquidations_1.CDPLiquidations.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cdpLiquidationsAll) {
            obj.cdpLiquidationsAll = message.cdpLiquidationsAll.map((e) => e ? cdp_liquidations_1.CDPLiquidations.toJSON(e) : undefined);
        }
        else {
            obj.cdpLiquidationsAll = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryCDPLiquidationsAllResponse);
        message.cdpLiquidationsAll = ((_a = object.cdpLiquidationsAll) !== null && _a !== void 0 ? _a : []).map((e) => cdp_liquidations_1.CDPLiquidations.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.RateStrategy = this.RateStrategy.bind(this);
        this.RateStrategyAll = this.RateStrategyAll.bind(this);
        this.AccountData = this.AccountData.bind(this);
        this.AccountCollateral = this.AccountCollateral.bind(this);
        this.AccountCollateralAll = this.AccountCollateralAll.bind(this);
        this.AccountDebt = this.AccountDebt.bind(this);
        this.AccountDebtAll = this.AccountDebtAll.bind(this);
        this.AccountStablecoin = this.AccountStablecoin.bind(this);
        this.Asset = this.Asset.bind(this);
        this.AssetAll = this.AssetAll.bind(this);
        this.TokenDebt = this.TokenDebt.bind(this);
        this.TokenDebtAll = this.TokenDebtAll.bind(this);
        this.StablecoinDebt = this.StablecoinDebt.bind(this);
        this.RewardSchemesAll = this.RewardSchemesAll.bind(this);
        this.RewardDebts = this.RewardDebts.bind(this);
        this.RewardDebtsAll = this.RewardDebtsAll.bind(this);
        this.PositionsAll = this.PositionsAll.bind(this);
        this.Position = this.Position.bind(this);
        this.HealthFactor = this.HealthFactor.bind(this);
        this.EMode = this.EMode.bind(this);
        this.EModeAll = this.EModeAll.bind(this);
        this.AccountEMode = this.AccountEMode.bind(this);
        this.StablecoinInterest = this.StablecoinInterest.bind(this);
        this.CDPLiquidationsAll = this.CDPLiquidationsAll.bind(this);
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    RateStrategy(request) {
        const data = exports.QueryRateStrategyRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "RateStrategy", data);
        return promise.then((data) => exports.QueryRateStrategyResponse.decode(new minimal_1.default.Reader(data)));
    }
    RateStrategyAll(request) {
        const data = exports.QueryRateStrategyAllRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "RateStrategyAll", data);
        return promise.then((data) => exports.QueryRateStrategyAllResponse.decode(new minimal_1.default.Reader(data)));
    }
    AccountData(request) {
        const data = exports.QueryAccountDataRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "AccountData", data);
        return promise.then((data) => exports.QueryAccountDataResponse.decode(new minimal_1.default.Reader(data)));
    }
    AccountCollateral(request) {
        const data = exports.QueryAccountCollateralRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "AccountCollateral", data);
        return promise.then((data) => exports.QueryAccountCollateralResponse.decode(new minimal_1.default.Reader(data)));
    }
    AccountCollateralAll(request) {
        const data = exports.QueryAccountCollateralAllRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "AccountCollateralAll", data);
        return promise.then((data) => exports.QueryAccountCollateralAllResponse.decode(new minimal_1.default.Reader(data)));
    }
    AccountDebt(request) {
        const data = exports.QueryAccountDebtRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "AccountDebt", data);
        return promise.then((data) => exports.QueryAccountDebtResponse.decode(new minimal_1.default.Reader(data)));
    }
    AccountDebtAll(request) {
        const data = exports.QueryAccountDebtAllRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "AccountDebtAll", data);
        return promise.then((data) => exports.QueryAccountDebtAllResponse.decode(new minimal_1.default.Reader(data)));
    }
    AccountStablecoin(request) {
        const data = exports.QueryAccountStablecoinRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "AccountStablecoin", data);
        return promise.then((data) => exports.QueryAccountStablecoinResponse.decode(new minimal_1.default.Reader(data)));
    }
    Asset(request) {
        const data = exports.QueryAssetRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "Asset", data);
        return promise.then((data) => exports.QueryAssetResponse.decode(new minimal_1.default.Reader(data)));
    }
    AssetAll(request) {
        const data = exports.QueryAssetAllRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "AssetAll", data);
        return promise.then((data) => exports.QueryAssetAllResponse.decode(new minimal_1.default.Reader(data)));
    }
    TokenDebt(request) {
        const data = exports.QueryTokenDebtRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "TokenDebt", data);
        return promise.then((data) => exports.QueryTokenDebtResponse.decode(new minimal_1.default.Reader(data)));
    }
    TokenDebtAll(request) {
        const data = exports.QueryTokenDebtAllRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "TokenDebtAll", data);
        return promise.then((data) => exports.QueryTokenDebtAllResponse.decode(new minimal_1.default.Reader(data)));
    }
    StablecoinDebt(request) {
        const data = exports.QueryStablecoinDebtRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "StablecoinDebt", data);
        return promise.then((data) => exports.QueryStablecoinDebtResponse.decode(new minimal_1.default.Reader(data)));
    }
    RewardSchemesAll(request) {
        const data = exports.QueryRewardSchemesAllRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "RewardSchemesAll", data);
        return promise.then((data) => exports.QueryRewardSchemesAllResponse.decode(new minimal_1.default.Reader(data)));
    }
    RewardDebts(request) {
        const data = exports.QueryRewardDebtsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "RewardDebts", data);
        return promise.then((data) => exports.QueryRewardDebtsResponse.decode(new minimal_1.default.Reader(data)));
    }
    RewardDebtsAll(request) {
        const data = exports.QueryRewardDebtsAllRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "RewardDebtsAll", data);
        return promise.then((data) => exports.QueryRewardDebtsResponse.decode(new minimal_1.default.Reader(data)));
    }
    PositionsAll(request) {
        const data = exports.QueryCdpPositionsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "PositionsAll", data);
        return promise.then((data) => exports.QueryCdpPositionsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Position(request) {
        const data = exports.QueryCdpPositionRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "Position", data);
        return promise.then((data) => exports.QueryCdpPositionResponse.decode(new minimal_1.default.Reader(data)));
    }
    HealthFactor(request) {
        const data = exports.QueryHealthFactorRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "HealthFactor", data);
        return promise.then((data) => exports.QueryHealthFactorResponse.decode(new minimal_1.default.Reader(data)));
    }
    EMode(request) {
        const data = exports.QueryEModeRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "EMode", data);
        return promise.then((data) => exports.QueryEModeResponse.decode(new minimal_1.default.Reader(data)));
    }
    EModeAll(request) {
        const data = exports.QueryEModeAllRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "EModeAll", data);
        return promise.then((data) => exports.QueryEModeAllResponse.decode(new minimal_1.default.Reader(data)));
    }
    AccountEMode(request) {
        const data = exports.QueryAccountEModeRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "AccountEMode", data);
        return promise.then((data) => exports.QueryAccountEModeResponse.decode(new minimal_1.default.Reader(data)));
    }
    StablecoinInterest(request) {
        const data = exports.QueryStablecoinInterestRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "StablecoinInterest", data);
        return promise.then((data) => exports.QueryStablecoinInterestResponse.decode(new minimal_1.default.Reader(data)));
    }
    CDPLiquidationsAll(request) {
        const data = exports.QueryCDPLiquidationsAllRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Query", "CDPLiquidationsAll", data);
        return promise.then((data) => exports.QueryCDPLiquidationsAllResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
